import axios from 'axios';

import {
  FETCH_GREAT_DEALS_NEW_ARRIVALS,
  FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS,
  FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE,
  UPDATE_GREAT_DEALS,
  UPDATE_GREAT_DEALS_SUCCESS,
  UPDATE_GREAT_DEALS_FAILURE,
  UPDATE_NEW_ARRIVALS,
  UPDATE_NEW_ARRIVALS_SUCCESS,
  UPDATE_NEW_ARRIVALS_FAILURE,
  FETCH_BILLBOARD_IMAGES,
  FETCH_BILLBOARD_IMAGES_SUCCESS,
  FETCH_BILLBOARD_IMAGES_FAILURE,
  SAVE_BILLBOARD_IMAGES,
  SAVE_BILLBOARD_IMAGES_SUCCESS,
  SAVE_BILLBOARD_IMAGES_FAILURE,
  DELETE_BILLBOARD_IMAGE,
  DELETE_BILLBOARD_IMAGE_SUCCESS,
  DELETE_BILLBOARD_IMAGE_FAILURE,
} from './type';

import { ROOT_URL, isGGI } from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';

function fetchingGreatDealsNewArrivals() {
  return {
    type: FETCH_GREAT_DEALS_NEW_ARRIVALS,
  };
}

function fetchGreatDealsNewArrivalsSuccess(data) {
  return {
    type: FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS,
    payload: data,
  };
}

function fetchGreatDealsNewArrivalsFailure(error) {
  return {
    type: FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE,
    payload: error,
  };
}

export function fetchGreatDealsNewArrivals() {
  return (dispatch) => {
    dispatch(fetchingGreatDealsNewArrivals());
    const token = localStorage.getItem('token');
    return axios({
      method: 'get',
      url: `${ROOT_URL}v1/product/great_deal_new_arrival/`,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        dispatch(fetchGreatDealsNewArrivalsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchGreatDealsNewArrivalsFailure(err));               
        }
      });
  };
}

function updatingGreatDeals() {
  return {
    type: UPDATE_GREAT_DEALS,
  };
}

function updateGreatDealsSuccess(data) {
  return {
    type: UPDATE_GREAT_DEALS_SUCCESS,
    payload: data,
  };
}

function updateGreatDealsFailure(error) {
  return {
    type: UPDATE_GREAT_DEALS_FAILURE,
    payload: error,
  };
}

/*
* @ids - array of product ids
* @isGreatDeal - boolean type indicating whether isGreatDeal or not for the
*                list of products (ids)
*/
export function updateGreatDeals(ids, isGreatDeal) {
  return (dispatch) => {
    dispatch(updatingGreatDeals());
    const token = localStorage.getItem('token');
    return axios({
      method: 'put',
      url: `${ROOT_URL}v1/product/great_deal/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        Product_ids: ids,
        IsGreatDeal: isGreatDeal,
      },
    })
      .then((response) => {
        dispatch(updateGreatDealsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(updateGreatDealsFailure(err));               
        }
      });
  };
}

function updatingNewArrivals() {
  return {
    type: UPDATE_NEW_ARRIVALS,
  };
}

function updateNewArrivalsSuccess(data) {
  return {
    type: UPDATE_NEW_ARRIVALS_SUCCESS,
    payload: data,
  };
}

function updateNewArrivalsFailure(error) {
  return {
    type: UPDATE_NEW_ARRIVALS_FAILURE,
    payload: error,
  };
}

/*
* @ids - array of product ids
* @isNewArrival - boolean type indicating whether isNewArrival or not for the
*                list of products (ids)
*/
export function updateNewArrivals(ids, isNewArrival) {
  return (dispatch) => {
    dispatch(updatingNewArrivals());
    const token = localStorage.getItem('token');
    return axios({
      method: 'put',
      url: `${ROOT_URL}v1/product/new_arrival/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        Product_ids: ids,
        IsNewArrival: isNewArrival,
      },
    })
      .then((response) => {
        dispatch(updateNewArrivalsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(updateNewArrivalsFailure(err));               
        }
      });
  };
}

function fetchingBillboardImages() {
  return {
    type: FETCH_BILLBOARD_IMAGES,
  };
}

function fetchBillboardImagesSuccess(data) {
  return {
    type: FETCH_BILLBOARD_IMAGES_SUCCESS,
    payload: data,
  };
}

function fetchBillboardImagesFailure(error) {
  return {
    type: FETCH_BILLBOARD_IMAGES_FAILURE,
    payload: error,
  };
}

export function fetchBillboardImages() {
  return (dispatch) => {
    dispatch(fetchingBillboardImages());
    const token = localStorage.getItem('token');
    return axios({
      method: 'get',
      url: `${ROOT_URL}v1/mobile/billboard/`,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        dispatch(fetchBillboardImagesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchBillboardImagesFailure(err));               
        }
      });
  };
}

function savingBillboardImages() {
  return {
    type: SAVE_BILLBOARD_IMAGES,
  };
}

function saveBillboardImagesSuccess(data) {
  return {
    type: SAVE_BILLBOARD_IMAGES_SUCCESS,
    payload: data,
  };
}

function saveBillboardImagesFailure(error) {
  return {
    type: SAVE_BILLBOARD_IMAGES_FAILURE,
    payload: error,
  };
}

/*
*@billboardImagesList = ["Image", "Index", "IsEnabled", "URL", "Language"]
*/
export function saveBillboardImages(billboardImagesList) {
  return (dispatch) => {
    dispatch(savingBillboardImages());
    const token = localStorage.getItem('token');
    return axios({
      method: 'post',
      url: `${ROOT_URL}v1/mobile/billboard/`,
      headers: { Authorization: `Bearer ${token}` },
      data: billboardImagesList,
    })
      .then((response) => {
        dispatch(saveBillboardImagesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(saveBillboardImagesFailure(err));               
        }
      });
  };
}

function deletingBillboardImage() {
  return {
    type: DELETE_BILLBOARD_IMAGE,
  };
}

function deleteBillboardImageSuccess(data) {
  return {
    type: DELETE_BILLBOARD_IMAGE_SUCCESS,
    payload: data,
  };
}

function deleteBillboardImageFailure(error) {
  return {
    type: DELETE_BILLBOARD_IMAGE_FAILURE,
    payload: error,
  };
}

/*
*@id of the image. Only images that are saved on the backend
*  have an id.
*/
export function deleteBillboardImage(id) {
  return (dispatch) => {
    dispatch(deletingBillboardImage());
    const token = localStorage.getItem('token');
    return axios({
      method: 'delete',
      url: `${ROOT_URL}v1/mobile/billboard/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        dispatch(deleteBillboardImageSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteBillboardImageFailure(err));               
        }
      });
  };
}

/**
* @param {String} html serialized string html
* @param {func} handleSuccess callback function for success
* @param {func} handleFailure callback function for failure
*/
export const saveFAQBoxText = (html, handleSuccess, handleFailure) => {
  const config = {
    method: 'put',
    url: `${ROOT_URL}v1/mobile/faq`,
    data: {
      rich_text: html,
    },
  };
  const token = localStorage.getItem('token');
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      handleFailure(err.data);           
    }
  });
};

/**
* @param {func} handleSuccess callback function for success
* @param {func} handleFailure callback function for failure
*/
export const fetchFAQBoxText = (handleSuccess, handleFailure) => {
  const config = {
    method: 'get',
    url: `${ROOT_URL}v1/mobile/faq`,
  };
  const token = localStorage.getItem('token');
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      handleFailure(err.data);           
    }
  });
};



// WEBPACK FOOTER //
// ./master/jsx/actions/mobileManagement_actions.js